/* eslint-disable no-plusplus */
/* eslint-disable no-unused-expressions */
/* eslint-disable no-param-reassign */
/* eslint-disable no-underscore-dangle */
/* eslint-disable max-len */
// text style        ["stroke","strokeWidth","fill","fontFamily","fontSize","fontWeight",
// "fontStyle","underline","overline","linethrough","deltaY","textBackgroundColor"]
import { fabric } from 'fabric';
import { generateId } from '../../utils';
import { FABRIC_CUSTOM_OBJECT } from '../../utils/constants';

fabric.Slider = fabric.util.createClass(fabric.Rect, {
  type: FABRIC_CUSTOM_OBJECT.slider,
  initialize(options) {
    options || (options = {});
    this.callSuper('initialize', options);
    this.set('name', FABRIC_CUSTOM_OBJECT.slider);
    this.set('percent', options.percent);
    this.set('rectStyle', { ...options.rectStyle });
    this.set('circleStyle', { ...options.circleStyle });
    this.set('padding', options.padding);
    this.set('id', options.id || generateId());
    // this.set({ hasBorders: false, hasControls: false });
    this.set('type', FABRIC_CUSTOM_OBJECT.slider);
    this.objectCaching = false;
    this.set({ padding: Math.abs(this.circleStyle.radius - this.height / 2) });

    this.on('scaled', () => {
      if (this.scaleX === 1 && this.scaleY === 1) return;

      const width = this.getScaledWidth();
      const height = this.getScaledHeight();
      this.set({
        scaleX: 1,
        scaleY: 1,
        width,
        height,
        circleStyle: {
          ...this.circleStyle,
          radius: Math.max(this.circleStyle.radius, height / 2),
        },
      });
      this.set({ padding: Math.abs(this.circleStyle.radius - this.height / 2) });
      this.setCoords();
    });
  },
  toObject() {
    return fabric.util.object.extend(this.callSuper('toObject'), {
      id: this.get('id'),
      rectStyle: this.get('rectStyle'),
      circleStyle: this.get('circleStyle'),
      percent: this.get('percent'),
      padding: this.get('padding'),
    });
  },
  toSVG() {
    const { left, top, percent, width, rx, ry, strokeWidth } = this;
    const myRx = parseInt(this.rx);
    if (myRx > this.height / 2) this.set({ rx: this.height / 2 });
    const rect = new fabric.Rect({
      ...this.rectStyle,
      height: this.height - strokeWidth,
      width: width - (width * percent) / 100 - strokeWidth + Math.min(this.height / 2, rx),
      top: top + this.strokeWidth / 2,
      left: left + (width * percent) / 100 - Math.min(this.height / 2, rx),
      rx: Math.max(rx - strokeWidth / 2, 0),
      ry: Math.max(ry - strokeWidth / 2, 0),
      strokeWidth: this.strokeWidth,
      stroke: 'transparent',
    });
    const rect2 = new fabric.Rect({
      ...this.rectStyle,
      height: this.height - strokeWidth,
      width: width - (width * percent) / 100 - Math.max(rx, this.strokeWidth),
      top: top + this.strokeWidth / 2,
      left: left + (width * percent) / 100,
      strokeWidth: this.strokeWidth,
      stroke: 'transparent',
    });
    const circle = new fabric.Circle({
      ...this.circleStyle,
      top: top + this.height / 2 + this.strokeWidth / 2,
      left: left + (width * percent) / 100,
      originX: 'center',
      originY: 'center',
      width: this.circleStyle.radius * 2 + this.strokeWidth * 2,
      height: this.circleStyle.radius * 2 + this.strokeWidth * 2,
      objectCaching: false,
    });
    this.set({ padding: Math.abs(this.circleStyle.radius - this.height / 2) });
    this.setCoords();
    return this.callSuper('toSVG') + rect.toSVG() + rect2.toSVG() + circle.toSVG();
  },
  _render(ctx) {
    const { percent, width, rx, ry, strokeWidth } = this;
    const myRx = parseInt(this.rx);
    if (myRx > this.height / 2) this.set({ rx: this.height / 2 });
    const rect = new fabric.Rect({
      ...this.rectStyle,
      height: this.height - strokeWidth,
      width: width - (width * percent) / 100 - strokeWidth + Math.min(this.height / 2, rx),
      top: -this.height / 2,
      left: -this.width / 2 + (width * percent) / 100 - Math.min(this.height / 2, rx),
      rx: Math.max(rx - strokeWidth / 2, 0),
      ry: Math.max(ry - strokeWidth / 2, 0),
      strokeWidth: this.strokeWidth,
      stroke: 'transparent',
    });
    const rect2 = new fabric.Rect({
      ...this.rectStyle,
      height: this.height - strokeWidth * 2,
      width: width - (width * percent) / 100 - Math.max(rx, this.strokeWidth),
      top: -this.height / 2 + this.stroke / 2,
      left: -this.width / 2 + (width * percent) / 100,
      strokeWidth: this.strokeWidth,
      stroke: 'transparent',
    });
    const circle = new fabric.Circle({
      ...this.circleStyle,
      top: 0,
      left: -this.width / 2 + (width * percent) / 100,
      objectCaching: false,
    });
    this.callSuper('_render', ctx);
    rect.render(ctx);
    rect2.render(ctx);
    circle.render(ctx);
  },
});
fabric.Slider.fromObject = function(options, callback) {
  const {
    top,
    left,
    width,
    height,
    stroke,
    strokeWidth,
    fill,
    rectStyle,
    circleStyle,
    rx,
    ry,
    id,
    percent,
    padding,
    angle,
  } = options;
  return callback(
    new fabric.Slider({
      top,
      left,
      width,
      height,
      stroke,
      strokeWidth,
      fill,
      rectStyle,
      circleStyle,
      rx,
      ry,
      id,
      percent,
      padding,
      angle,
    }),
  );
};
window.fabric.Slider = fabric.Slider;
export default fabric.Slider;
export function createCustomObj() {
  const rect = new fabric.Slider({
    name: FABRIC_CUSTOM_OBJECT.slider,
    width: 300,
    height: 50,
    stroke: '#000000',
    strokeWidth: 2,
    fill: '#ffffff',
    percent: 40,
    rectStyle: {
      name: 'left rect',
      width: 100,
      height: 50,
      stroke: '#000000',
      fill: '#ffffff',
      lockMovementX: true,
      lockMovementY: true,
      id: generateId(),
    },
    circleStyle: {
      fill: '#ffffff',
      stroke: '#000000',
      strokeWidth: 2,
      originX: 'center',
      originY: 'center',
      lockMovementY: true,
      id: generateId(),
    },
    id: generateId(),
  });
  return rect;
}
